import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NativeAppClassDirective } from './directives/native-app-class.directive';
import { NativeAppHiddenDirective } from './directives/native-app-hidden.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    NativeAppClassDirective,
    NativeAppHiddenDirective
  ],
  exports: [
    NativeAppClassDirective,
    NativeAppHiddenDirective
  ]
})
export class NativeAppInterfaceModule {}
